<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Broker"),
			cols: [
				{
					id: "offer_buy_id",
					name: "#BUY",
					render: (id) => "#" + id,
				},
				{
					id: "offer_sell_id",
					name: "#SELL",
					render: (id) => "#" + id,
				},
				{
					id: "buyer_company",
					name: this.__("Buyer"),
				},
				{
					id: "seller_company",
					name: this.__("Seller"),
				},
				{
					id: "product__grade",
					name: this.__("Article"),
					render: (x, row) =>
						window.__(
							options.getLabel(row.product__grade, options.productGradeOptions)
						),
				},
				{
					id: "product__harvest",
					name: this.__("At Harvest"),
				},
				{
					id: "price_FCA",
					name: this.__("FCA Price"),
				},
				{
					id: "qty__mt_least",
					name: this.__("Quantity"),
				},
				{
					id: "date__type",
					name: this.__("Fulfilment Date"),
					render: (m) =>
						window.__(options.getLabel(m, options.dateModeOptions)),
				},
				{
					id: "date__range",
					name: this.__("Period"),
					render: (x, row) =>
						[
							row.date__month_from ? row.date__month_from.substr(2, 5) : "",
							" - ",
							row.date__month_to ? row.date__month_to.substr(2, 5) : "",
						].join(""),
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return (
				window.baseUrl +
				"/admin/alt_brokers/" +
				row.offer_buy_id.replace("#", "") +
				"/" +
				row.offer_sell_id.replace("#", "")
			);
		},
	},
};
</script>
